const blockedGeneratedToolDemoSlugs = new Set([
	"genogram",
	"genogram-online",
	"genogram-for-education",
])

const standaloneToolPageSlugs = new Set([
	...blockedGeneratedToolDemoSlugs,
	"wheel-of-life",
])

function isGeneratedToolDemoBlockedSlug(slug) {
	return blockedGeneratedToolDemoSlugs.has(slug)
}

function isStandaloneToolPageSlug(slug) {
	return standaloneToolPageSlugs.has(slug)
}

exports.blockedGeneratedToolDemoSlugs = blockedGeneratedToolDemoSlugs
exports.standaloneToolPageSlugs = standaloneToolPageSlugs
exports.protectedToolDemoSlugs = standaloneToolPageSlugs
exports.isGeneratedToolDemoBlockedSlug = isGeneratedToolDemoBlockedSlug
exports.isStandaloneToolPageSlug = isStandaloneToolPageSlug
exports.isProtectedToolDemoSlug = isStandaloneToolPageSlug
